import axios from "axios"
import _ from "lodash"
import { useEffect, useState } from "react"
import { getReport } from "services/reports/calls"

export const useAPI = (reportId, filters, reRender) => {
  const [error, setError] = useState(null)
  const [isLoading, handleLoading] = useState(true)
  const [payload, setPayload] = useState([])

  useEffect(() => {
    const source = axios.CancelToken.source()
    let isMounted = true
    const fetchAPI = async () => {
      try {
        handleLoading(true)
        const _filters = _.cloneDeep(filters)
        const { payload } = await getReport(_filters, reportId, source.token)
        if (isMounted) {
          setPayload(payload)
        }
      } catch (err) {
        // console.error(err)
        if (isMounted) {
          setError(err)
        }
      } finally {
        isMounted && handleLoading(false)
      }
    }

    fetchAPI()
    const cleanUp = () => {
      isMounted = false
      source.cancel()
    }
    return cleanUp
  }, [reportId, reRender])
  return { payload, isLoading, error }
}
